import qNews from '@assets/gql/news.gql';
import qNewsCategories from '@assets/gql/news.categories.gql';
import qNaujienosUniqueDates from '@assets/gql/naujienosUniqueDates.gql';
import { useQuery } from '@apollo/client';
import React, { useEffect, useRef, useState } from 'react';
import client from '@gql/client';
import { CardSimple } from '@assets/tsx/card/simple';
import { nestCategories } from "./nestCategories";
import Button from '@widgets/button/button';
import { PaginatorButtons } from '@assets/tsx/paginator/buttons';
import Dropdown from '@assets/tsx/dropdown';
import OutsideAlerter from '@assets/tsx/outsideClicker';
import { useArchiveYear } from '@ambiguous/useArchiveYear';
import { Link } from '@ambiguous/link';
import { useLang } from '@ambiguous/useLang';
import { LoadingBox } from '@assets/tsx/loadingBox/loadingBox';
import { useListContext } from '@assets/spa/context/list';
import { useRouterPath } from '@ambiguous/useRouterPath';
import { useI18n } from '@wordpress/react-i18n';
export default function News({ _id, title, perPage, stretchFirst, categories, buttons, pagination, archive, prefetch, isHero }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const [lang] = useLang();
    if ((_b = (_a = prefetch === null || prefetch === void 0 ? void 0 : prefetch.categories) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.naujienosKategorijos) {
        client.writeQuery({
            query: qNewsCategories,
            variables: { include: categories, language: lang === null || lang === void 0 ? void 0 : lang.toUpperCase() },
            data: prefetch.categories.data
        });
    }
    const [lists, setLists] = useListContext();
    const listData = lists ? (lists[_id] || {}) : {};
    const [path] = useRouterPath();
    const [page, setPage] = useState((listData === null || listData === void 0 ? void 0 : listData.page) || 0);
    const archive_year = useArchiveYear();
    const [activeCategory, setActiveCategory] = useState((listData === null || listData === void 0 ? void 0 : listData.activeCategory) || null);
    const { items, loading, fetchMore, total, heroItem } = useNewsItems(!!activeCategory ? activeCategory : categories, perPage, page, setPage, archive_year, isHero);
    useEffect(() => {
        setLists && setLists((prev) => (Object.assign(Object.assign({}, prev), { [_id]: { path, page, activeCategory } })));
    }, [page, activeCategory]);
    const [wrap, setWrap] = useState();
    const { __ } = useI18n();
    return (React.createElement("div", { className: 'ltg-posts', ref: setWrap },
        !!title && (React.createElement("h2", { className: "ltg-posts-title" }, title)),
        React.createElement("div", { className: "ltg-posts-buttons" },
            React.createElement(Filters, { categories: categories, activeCategory: activeCategory, setActiveCategory: setActiveCategory, setPage: setPage }),
            ((buttons === null || buttons === void 0 ? void 0 : buttons.length) > 0 && archive !== 'yes') && (React.createElement("div", { className: "ltg-posts-btn-wrap" }, buttons.map((btn) => {
                var _a, _b;
                // TODO : ne pilnai dinaminis
                const dynamicUrl = (_a = btn === null || btn === void 0 ? void 0 : btn.url__props) === null || _a === void 0 ? void 0 : _a.url;
                if (((_b = btn === null || btn === void 0 ? void 0 : btn.url__props) === null || _b === void 0 ? void 0 : _b.type) == 'dynamic' && !!dynamicUrl) {
                    btn.url = dynamicUrl;
                }
                return React.createElement(Button, Object.assign({ key: btn._id }, btn));
            }))),
            archive === 'yes' && React.createElement(ArchiveDropdown, { categories: categories === null || categories === void 0 ? void 0 : categories.map(c => c.toString()), prefetch: prefetch === null || prefetch === void 0 ? void 0 : prefetch.archive_years, archiveYear: archive_year, setPage: setPage })),
        (loading == false && (items === null || items === void 0 ? void 0 : items.length) === 0) ? (React.createElement("h1", { role: 'presentation', style: { textAlign: 'center', margin: '2rem 0' } }, __("Naujienų nėra", 'ltg-widgets'))) : (React.createElement(React.Fragment, null,
            heroItem &&
                React.createElement("div", { className: "ltg-news-hero-item" },
                    React.createElement(CardSimple, { title: heroItem.title, date: heroItem.date, uri: heroItem.uri, altText: (_d = (_c = heroItem === null || heroItem === void 0 ? void 0 : heroItem.featuredImage) === null || _c === void 0 ? void 0 : _c.node) === null || _d === void 0 ? void 0 : _d.altText, mediaItemUrl: (_f = (_e = heroItem === null || heroItem === void 0 ? void 0 : heroItem.featuredImage) === null || _e === void 0 ? void 0 : _e.node) === null || _f === void 0 ? void 0 : _f.sourceUrl, mediaItemSrcSet: (_h = (_g = heroItem === null || heroItem === void 0 ? void 0 : heroItem.featuredImage) === null || _g === void 0 ? void 0 : _g.node) === null || _h === void 0 ? void 0 : _h.srcSet, categoryName: (_k = (_j = heroItem === null || heroItem === void 0 ? void 0 : heroItem.naujienosKategorijos) === null || _j === void 0 ? void 0 : _j.nodes) === null || _k === void 0 ? void 0 : _k.map(c => c.name).join(', '), hasFeaturedVideo: heroItem.hasFeaturedVideo, hasFeaturedGallery: heroItem.hasFeaturedGallery })),
            React.createElement(NewsList, { stretchFirst: stretchFirst === 'yes' && !archive_year, items: loading ? new Array(perPage).fill('loading') : items, loading: loading }),
            ((pagination === 'yes' || archive === 'yes') && total > 1) && (React.createElement("div", { className: "ltg-posts-paginator-wrap" },
                React.createElement(PaginatorButtons, { total: total, key: activeCategory || 'all', page: page, onClick: (clickedPage) => {
                        fetchMore(clickedPage).then(() => {
                            wrap && wrap.scrollIntoView({ behavior: 'smooth' });
                        });
                    } })))))));
}
const NewsList = (props) => {
    const { stretchFirst, items, loading } = props;
    return (React.createElement("div", { className: `ltg-posts-list${stretchFirst ? ' stretch-first' : ''}` }, items.map((newsItem, index) => {
        if (typeof newsItem === 'string') {
            return React.createElement(LoadingBox, { key: `news-loader-${index}`, style: { paddingBottom: '56.25%' } });
        }
        const { date, featuredImage, hasFeaturedGallery, hasFeaturedVideo, id, title, uri, naujienosKategorijos } = newsItem;
        const { altText, sourceUrl, srcSet } = (featuredImage === null || featuredImage === void 0 ? void 0 : featuredImage.node) || {};
        const categoryNameArr = naujienosKategorijos === null || naujienosKategorijos === void 0 ? void 0 : naujienosKategorijos.nodes.map(c => c.name);
        const categoryName = (categoryNameArr && (categoryNameArr === null || categoryNameArr === void 0 ? void 0 : categoryNameArr.length) > 0) ? categoryNameArr.join(', ') : null;
        return React.createElement(CardSimple, { key: id, title: title, date: date, uri: uri, altText: altText, mediaItemUrl: sourceUrl, mediaItemSrcSet: srcSet, categoryName: categoryName, hasFeaturedVideo: hasFeaturedVideo, hasFeaturedGallery: hasFeaturedGallery });
    })));
};
const Filters = (props) => {
    var _a;
    const { __ } = useI18n();
    const { setPage, categories, activeCategory, setActiveCategory } = props;
    const nestedCategories = useCategoriesFilters(categories);
    const onClick = (databaseId) => {
        setPage(0);
        setActiveCategory(databaseId == null ? null : databaseId.toString());
    };
    function recursiveButtons(buttons) {
        if (!(buttons === null || buttons === void 0 ? void 0 : buttons.length))
            return null;
        return buttons.map((filterBtn, index) => {
            const { name, id, databaseId, children } = filterBtn;
            return (React.createElement(React.Fragment, { key: id || 'filter-btn-sub' + index },
                name && React.createElement(FilterButton, { name: name, active: databaseId.toString() === (activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.toString()), onClick: () => { onClick(databaseId); } }),
                (children === null || children === void 0 ? void 0 : children.length) > 0 && recursiveButtons(children)));
        });
    }
    if ((nestedCategories === null || nestedCategories === void 0 ? void 0 : nestedCategories.length) == 0) {
        return null;
    }
    if ((nestedCategories === null || nestedCategories === void 0 ? void 0 : nestedCategories.length) == 1 && ((_a = nestedCategories[0].children) === null || _a === void 0 ? void 0 : _a.length) === 0) {
        return null;
    }
    return (React.createElement("div", { className: "ltg-posts-filters" },
        React.createElement("div", { className: "btn-group" },
            React.createElement(FilterButton, { name: __('Visos naujienos', 'ltg-widgets'), active: !activeCategory, onClick: () => { onClick(null); } })),
        nestedCategories.map((filterBtn, index) => {
            const { name, id, databaseId, children } = filterBtn;
            return (React.createElement("div", { className: 'btn-group', key: id || 'filter-btn' + index },
                name && React.createElement(FilterButton, { name: name, active: databaseId.toString() === (activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.toString()), onClick: () => { onClick(databaseId); } }),
                recursiveButtons(children)));
        })));
};
function useNewsItems(activeCategory, perPage, page, setPage, archiveYear, isHero) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const taxArray = (activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.length) > 0 ? [{
            field: 'TAXONOMY_ID',
            operator: 'IN',
            taxonomy: 'NAUJIENOSKATEGORIJA',
            terms: activeCategory
        }] : undefined;
    const [language] = useLang();
    const { currentDate, prevYearDate: nextYearDate } = getYearsObj();
    const dateQuery = archiveYear ? {
        column: 'DATE',
        before: {
            day: 1,
            month: 1,
            year: +archiveYear + 1
        },
        after: {
            day: 31,
            month: 12,
            year: +archiveYear - 1
        }
    } : {
        column: 'DATE',
        after: {
            year: nextYearDate.year,
            month: nextYearDate.month,
            day: nextYearDate.day
        }
    };
    const orderby = [
        { field: 'DATE', order: 'DESC' }
    ];
    if (!archiveYear) {
        orderby.unshift({ field: 'META_KEY', order: 'DESC', metaKeyField: "post_is_priority" });
    }
    if (isHero === 'yes') {
        orderby.unshift({ field: "META_KEY", order: "DESC", metaKeyField: "post_is_hero" });
        // console.log({page})
    }
    const { data, loading, refetch } = useQuery(qNews, {
        client,
        variables: {
            offset: page * perPage,
            orderby,
            perPage: (isHero === 'yes' && page === 0) ? perPage + 1 : perPage,
            taxArray,
            dateQuery,
            language: (language === null || language === void 0 ? void 0 : language.toUpperCase()) || 'DEFAULT'
        }
    });
    const items = ((_b = (_a = data === null || data === void 0 ? void 0 : data.naujienos) === null || _a === void 0 ? void 0 : _a.edges) === null || _b === void 0 ? void 0 : _b.map(edge => edge.node)) || [];
    const hasMore = ((_e = (_d = (_c = data === null || data === void 0 ? void 0 : data.naujienos) === null || _c === void 0 ? void 0 : _c.pageInfo) === null || _d === void 0 ? void 0 : _d.offsetPagination) === null || _e === void 0 ? void 0 : _e.hasMore) || false;
    let totalItems = (_h = (_g = (_f = data === null || data === void 0 ? void 0 : data.naujienos) === null || _f === void 0 ? void 0 : _f.pageInfo) === null || _g === void 0 ? void 0 : _g.offsetPagination) === null || _h === void 0 ? void 0 : _h.total;
    const total = Math.ceil(totalItems / perPage) || 0;
    let heroItem;
    if (isHero === 'yes') {
        const heroItemIndex = items.findIndex(i => i.isHero);
        if (heroItemIndex !== -1) {
            heroItem = items.splice(heroItemIndex, 1)[0];
        }
    }
    const fetchMoreNewsItems = (page) => new Promise((res, rej) => {
        setPage(page);
        refetch({
            orderby,
            perPage: (isHero === 'yes' && page === 0) ? perPage + 1 : perPage,
            taxArray,
            dateQuery,
            offset: page * perPage,
            language: (language === null || language === void 0 ? void 0 : language.toUpperCase()) || 'DEFAULT'
        }).then(res).catch(err => { rej(err); });
    });
    return {
        items,
        loading,
        hasMore,
        total,
        fetchMore: fetchMoreNewsItems,
        heroItem,
    };
}
function useCategoriesFilters(include) {
    var _a;
    const [lang] = useLang();
    const { data, loading } = useQuery(qNewsCategories, { client, variables: {
            include,
            language: lang === null || lang === void 0 ? void 0 : lang.toUpperCase()
        } });
    if (loading)
        return [];
    const categories = ((_a = data === null || data === void 0 ? void 0 : data.naujienosKategorijos) === null || _a === void 0 ? void 0 : _a.nodes) || [];
    return nestCategories(categories);
}
export const FilterButton = ({ name, color, active, onClick, outlined }) => (React.createElement("button", { type: 'button', onClick: (ev) => { ev.preventDefault(); ev.stopPropagation(); onClick && onClick(); }, className: `btn${outlined !== false ? ' btn-outlined ' : ''}btn-${color || 'primary'}${active ? ' active' : ''}` }, name));
const ArchiveDropdown = (props) => {
    var _a;
    const { __ } = useI18n();
    const { categories, prefetch, archiveYear, setPage } = props;
    const [open, setOpen] = useState(false);
    const [lang] = useLang();
    const language = lang === null || lang === void 0 ? void 0 : lang.toUpperCase();
    const onClick = (isOpen) => {
        setOpen(isOpen);
        setPage(0);
    };
    if (prefetch === null || prefetch === void 0 ? void 0 : prefetch.data) {
        client.writeQuery({
            query: qNaujienosUniqueDates,
            data: prefetch.data,
            variables: { language }
        });
    }
    const { data, loading } = useQuery(qNaujienosUniqueDates, {
        variables: { language },
        client
    });
    const dates = useRef([]);
    if (!loading && dates.current.length === 0) {
        dates.current = data.naujienosUniqueDates;
    }
    const current_year = new Date().getFullYear().toString();
    return React.createElement("div", { className: 'btn-group' },
        React.createElement(Dropdown, { isPortal: true, minWidth: '156px', label: archiveYear ? archiveYear : __('Archyvas', 'ltg-widgets'), open: open, onClick: () => { setOpen(!open); } },
            React.createElement(OutsideAlerter, { callback: () => { setOpen(false); } }, (_a = dates === null || dates === void 0 ? void 0 : dates.current) === null || _a === void 0 ? void 0 : _a.reduce((agr, date) => {
                if (date === current_year)
                    return agr;
                return ([...agr, React.createElement("div", { key: date },
                        React.createElement(Link, { href: `/naujienos/${date !== current_year ? date : ''}`, className: `dropdown-item${date === archiveYear ? ' active' : ''}`, key: 'dd-' + date, onClick: () => { onClick(false); } }, date))]);
            }, []))));
};
export function getYearsObj() {
    const today = new Date();
    const currentDate = {
        year: today.getFullYear(),
        month: today.getMonth() + 1,
        day: today.getDate()
    };
    const prevYear = today.getFullYear() - 1;
    const prevYearDate = new Date(prevYear, today.getMonth(), today.getDate());
    const prevYearObject = {
        year: prevYearDate.getFullYear(),
        month: prevYearDate.getMonth() + 1,
        day: prevYearDate.getDate()
    };
    return { currentDate, prevYearDate: prevYearObject };
}
// function useArchiveYear(){
// 	if(typeof window === "undefined") return;
// 	const regex = /(naujienos)\/([0-9]+)/
// 	const archive_url_matches = window.location.pathname.match(regex);
// 	if(archive_url_matches === null) return null;
// 	return archive_url_matches?.at(2) ? archive_url_matches[2] : null;
// }
